export const USDT_PRICE = 1;
